/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { CostCalculationPercentageType } from '../types/utils';

export class CreateCostCalculationPercentageInput {
	annual?: number

	main?: number

	type: CostCalculationPercentageType = CostCalculationPercentageType.MONETARY_CONTRIBUTIONS
}